import { render, staticRenderFns } from "./userCreditsPaySuccess.vue?vue&type=template&id=a45be4f2&scoped=true"
import script from "./userCreditsPaySuccess.vue?vue&type=script&lang=js"
export * from "./userCreditsPaySuccess.vue?vue&type=script&lang=js"
import style0 from "./userCreditsPaySuccess.vue?vue&type=style&index=0&id=a45be4f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45be4f2",
  null
  
)

export default component.exports